import React, { useCallback, useEffect, useState } from 'react';
import { Center, Spinner } from '@chakra-ui/react';
import Head from 'next/head';
import { LiffProvider, useLiff } from 'react-liff';
import { useRouter } from 'next/router';
import axios from 'axios';

const LINE_OA_URI = process.env.NEXT_PUBLIC_LINE_OA_ID;

function Invite() {
  const liffId = process.env.NEXT_PUBLIC_LINE_LIFF_ID;
  return (
    <LiffProvider liffId={liffId}>
      <InviteComponent />
    </LiffProvider>
  );
}

function InviteComponent() {
  const router = useRouter();
  const [idToken, setIdToken] = useState('');
  const { error, liff, isLoggedIn, ready } = useLiff();
  const updateRefProfile = useCallback(async () => {
    const { source, source_from } = router.query;
    try {
      if (!source || !ready) {
        return;
      }
      await axios.post('/api/line/reference', {
        source,
        source_from,
        idToken,
      });
    } catch (error) {
      console.error(error);
    } finally {
      liff.closeWindow();
      window.location.href = LINE_OA_URI;
    }
  }, [axios, liff, router]);

  const liffUpdate = useCallback(async () => {
    // link to oa account if error.
    if (error) {
      return (window.location.href = LINE_OA_URI);
    }
    if (!ready) {
      return;
    }
    if (!isLoggedIn) {
      return liff.login();
    }

    if (isLoggedIn && idToken.length > 0) {
      updateRefProfile();
    }
  }, [ready, liff, isLoggedIn, idToken, updateRefProfile]);

  useEffect(() => {
    if (!isLoggedIn) return;

    (async () => {
      const liffIdToken = await liff.getIDToken();
      setIdToken(liffIdToken);
      liffUpdate();
    })();
  }, [liff, isLoggedIn]);

  useEffect(() => {
    if (idToken.length > 0) {
      updateRefProfile();
    }
  }, [idToken]);

  return (
    <div>
      <Head>
        <title>FUNWOO Invitation</title>
      </Head>
      <Center>{!ready && <Spinner size='xl' emptyColor='gray.200' speed='.8s' thickness='4px' />}</Center>
    </div>
  );
}

export default Invite;
